"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ToolbarOverflowComponent: true
};
exports.default = exports.ToolbarOverflowComponent = void 0;
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _Icon = require("../Icon/Icon");
var _IconButton = require("../IconButton/IconButton");
var _Overlay = require("../Overlay/Overlay");
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _constants = require("../utils/constants");
var _useFocusManager = require("../utils/useFocusManager");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _isFunction = require("../utils/isFunction");
var _ToolbarOverflowLayout = require("./_ToolbarOverflowLayout");
var _Toolbar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar.css") : void 0);
var _ToolbarOverflow = require("./ToolbarOverflow.types");
Object.keys(_ToolbarOverflow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ToolbarOverflow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ToolbarOverflow[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable react/jsx-no-bind */

const ToolbarOverflow = exports.ToolbarOverflowComponent = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  var _a;
  const {
      className,
      cssBlock = 'sapcnqr-toolbar',
      overflowButtonLabel,
      overflowButtonProps,
      onOverflowToggle,
      children,
      overlayProps,
      popperId: _popperId,
      maxHeight,
      showOverflowMenu
    } = props,
    otherProps = __rest(props, ["className", "cssBlock", "overflowButtonLabel", "overflowButtonProps", "onOverflowToggle", "children", "overlayProps", "popperId", "maxHeight", "showOverflowMenu"]);
  const [isOverlayOpen, setIsOverlayOpen] = (0, _react.useState)(showOverflowMenu);
  const [hasLeftIcon, setHasLeftIcon] = (0, _react.useState)(false);
  const [hasRightIcon, setHasRightIcon] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setIsOverlayOpen(showOverflowMenu);
  }, [showOverflowMenu]);
  const overflowTriggerRef = (0, _react.useRef)(null);
  const overflowRef = (0, _react.useRef)(null);
  let overflowDialogId = (0, _useUniqueId.default)();
  if ((_a = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.id) === null || _a === void 0 ? void 0 : _a.trim()) {
    overflowDialogId = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.id;
  }
  const classnames = _bind.default.bind(_Toolbar.default);
  (0, _useFocusManager.useFocusManager)({
    trapNode: overflowRef.current,
    nextKeyCode: _keycode.default.codes.down,
    previousKeyCode: _keycode.default.codes.up,
    firstFocusIndex: 0,
    onlyContainedEvents: true,
    trapWithTabbing: true,
    skipEvent: event => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
      const activeDescendantId = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.getAttribute) === null || _b === void 0 ? void 0 : _b.call(_a, 'aria-activedescendant');
      // if there is no active descendant, don't skip focus management
      if (!activeDescendantId) {
        return false;
      }
      // skip Toolbar focus management for SegmentedButton as it
      // manages its own active descendants.
      let firstOptionId = (_e = (_d = (_c = event.target) === null || _c === void 0 ? void 0 : _c.firstElementChild) === null || _d === void 0 ? void 0 : _d.getAttribute) === null || _e === void 0 ? void 0 : _e.call(_d, 'id');
      const lastOptionId = (_f = event.target) === null || _f === void 0 ? void 0 : _f.lastElementChild.getAttribute('id');
      // if segmented button has label get the 1st option like this:
      if (((_j = (_h = (_g = event.target) === null || _g === void 0 ? void 0 : _g.firstElementChild) === null || _h === void 0 ? void 0 : _h.getAttribute) === null || _j === void 0 ? void 0 : _j.call(_h, 'role')) === 'presentation') {
        firstOptionId = (_m = (_l = (_k = event.target) === null || _k === void 0 ? void 0 : _k.childNodes[1]) === null || _l === void 0 ? void 0 : _l.getAttribute) === null || _m === void 0 ? void 0 : _m.call(_l, 'id');
      }
      // if the active descendant is not the first or last option, skip focus management
      return activeDescendantId !== lastOptionId && (0, _keycode.default)(event) === 'down' || activeDescendantId !== firstOptionId && (0, _keycode.default)(event) === 'up';
    }
  }, !!(isOverlayOpen && (overflowRef === null || overflowRef === void 0 ? void 0 : overflowRef.current)), overflowRef);
  const classes = classnames(`${cssBlock}__overflow`, className);
  const toggle = value => {
    setIsOverlayOpen(value);
    if ((0, _isFunction.isFunction)(onOverflowToggle)) {
      onOverflowToggle(value);
    }
  };
  const overflowTrigger = /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, Object.assign({
    "aria-controls": isOverlayOpen ? overflowDialogId : undefined,
    "aria-expanded": isOverlayOpen,
    "aria-haspopup": true,
    iconName: "kebab"
  }, overflowButtonProps, {
    onClick: (0, _chainFunction.default)(() => toggle(!isOverlayOpen), overflowButtonProps === null || overflowButtonProps === void 0 ? void 0 : overflowButtonProps.onClick),
    className: classnames(`${cssBlock}__overflow-trigger`, overflowButtonProps === null || overflowButtonProps === void 0 ? void 0 : overflowButtonProps.className),
    active: isOverlayOpen,
    ariaLabel: overflowButtonLabel,
    ref: overflowTriggerRef
  }));
  const overflowPopperPlacement = ['right-start', 'left-start', 'right', 'left', 'left-end', 'right-end', 'top-start', 'bottom-start', 'top-end', 'bottom-end', 'auto'];
  const toolbarLayoutProps = {
    hasLeftIcon,
    hasRightIcon,
    setHasLeftIcon,
    setHasRightIcon
  };
  const addChildProps = (0, _react.useCallback)((classnamesFn, child, childProps) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (child.displayName === 'Toolbar.Start' || child.displayName === 'Toolbar.Center' || child.displayName === 'Toolbar.End') {
      return {
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, _constants.CSS_PREFIX, `${cssBlock}__overflow-item`, `${cssBlock}__overflow-region`)
      };
    }
    if (child.displayName === 'Overlay') {
      return (childProps === null || childProps === void 0 ? void 0 : childProps['data-skip-toolbar-overflow-transformations']) ? {} : {
        popperPlacement: overflowPopperPlacement,
        targetProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.targetProps), {
          className: classnamesFn((_a = childProps === null || childProps === void 0 ? void 0 : childProps.targetProps) === null || _a === void 0 ? void 0 : _a.className, `${cssBlock}__overflow-item`)
        }),
        targetComponent: (childProps === null || childProps === void 0 ? void 0 : childProps.targetComponent) && /*#__PURE__*/_react.default.cloneElement(childProps === null || childProps === void 0 ? void 0 : childProps.targetComponent, {
          toolbarOverflowEnd: (/*#__PURE__*/_react.default.createElement(_Icon.Icon, {
            ariaHidden: true,
            iconName: "arrow-2-e",
            forceSize: "xs-plus"
          }))
        })
      };
    }
    if (child.displayName === 'NavMenu') {
      return {
        inToolbarOverflow: true,
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, `${cssBlock}__overflow-item`),
        overlayProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.overlayProps), {
          popperPlacement: overflowPopperPlacement,
          targetClassName: classnamesFn((_b = childProps === null || childProps === void 0 ? void 0 : childProps.overlayProps) === null || _b === void 0 ? void 0 : _b.targetClassName, `${cssBlock}__overflow-item`)
        }),
        buttonProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.buttonProps), {
          inToolbarOverflow: true,
          toolbarLayoutProps
        }),
        iconProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.iconProps), {
          iconName: 'arrow-2-e'
        })
      };
    }
    if (child.displayName === 'IconButton') {
      return {
        toolbarLayoutProps,
        inToolbarOverflow: (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false,
        className: classnamesFn(_constants.CSS_PREFIX, `${_constants.CSS_PREFIX}-button-in-overflow`, childProps === null || childProps === void 0 ? void 0 : childProps.className, {
          [`${cssBlock}__overflow-item`]: (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false,
          [`${cssBlock}__overflow-button`]: (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false
        }),
        innerProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.innerProps), {
          className: classnamesFn({
            [`${cssBlock}__overflow-button-inner`]: (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false
          })
        })
      };
    }
    if (child.displayName === 'IconLink') {
      return {
        toolbarLayoutProps,
        inToolbarOverflow: true
      };
    }
    if (child.displayName === 'FormField') {
      return {
        layout: 'vertical'
      };
    }
    if (child.displayName === 'SegmentedButton') {
      const listItemRenderer = ({
        text,
        icon,
        key
      } = {}) => (/*#__PURE__*/_react.default.createElement(_ToolbarOverflowLayout.ToolbarOverflowLayout, Object.assign({
        startIconOrBadge: icon && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
          ariaHidden: true,
          iconName: icon
        }),
        centerText: text,
        endIconOrBadge: (childProps === null || childProps === void 0 ? void 0 : childProps.selectedKey) === key && (/*#__PURE__*/_react.default.createElement(_Icon.Icon, {
          ariaHidden: true,
          iconName: "check",
          className: classnames(`${cssBlock}__overflow-check-icon`)
        }))
      }, toolbarLayoutProps)));
      return {
        selectionFollowsFocus: false,
        orientation: 'vertical',
        listItemRenderer,
        label: (childProps === null || childProps === void 0 ? void 0 : childProps.label) || (childProps === null || childProps === void 0 ? void 0 : childProps.ariaLabel),
        labelProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.labelProps), {
          className: classnames((_c = childProps === null || childProps === void 0 ? void 0 : childProps.labelProps) === null || _c === void 0 ? void 0 : _c.className, `${cssBlock}__overflow-segmented-button-label`)
        }),
        listItemProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.listItemProps), {
          className: classnames((_d = childProps === null || childProps === void 0 ? void 0 : childProps.listItemProps) === null || _d === void 0 ? void 0 : _d.className, `${cssBlock}__overflow-segmented-button-item`),
          itemWrapperProps: Object.assign(Object.assign({}, (_e = childProps === null || childProps === void 0 ? void 0 : childProps.listItemProps) === null || _e === void 0 ? void 0 : _e.itemWrapperProps), {
            className: classnames(_constants.CSS_PREFIX, (_g = (_f = childProps === null || childProps === void 0 ? void 0 : childProps.listItemProps) === null || _f === void 0 ? void 0 : _f.itemWrapperProps) === null || _g === void 0 ? void 0 : _g.className, `${cssBlock}__overflow-segmented-button-item-wrapper`)
          })
        }),
        className: classnames(_constants.CSS_PREFIX, childProps === null || childProps === void 0 ? void 0 : childProps.className, `${cssBlock}__overflow-segmented-button`, {
          [`${cssBlock}--no-left`]: !hasLeftIcon
        })
      };
    }
    if (child.displayName === 'Button') {
      return {
        toolbarLayoutProps,
        inToolbarOverflow: (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false,
        type: (childProps === null || childProps === void 0 ? void 0 : childProps['data-toolbar-group-part']) || (childProps === null || childProps === void 0 ? void 0 : childProps.type) === 'create' ? childProps === null || childProps === void 0 ? void 0 : childProps.type : 'link',
        className: classnamesFn(_constants.CSS_PREFIX, `${_constants.CSS_PREFIX}-button-in-overflow`, childProps === null || childProps === void 0 ? void 0 : childProps.className, {
          [`${cssBlock}__overflow-button`]: (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false,
          [`${cssBlock}__overflow-item`]: (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false
        }),
        innerProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.innerProps), {
          className: classnamesFn({
            [`${cssBlock}__overflow-button-inner`]: (childProps === null || childProps === void 0 ? void 0 : childProps.inToolbarOverflow) !== false
          })
        })
      };
    }
    if (child.displayName === 'MenuButton') {
      return {
        inToolbarOverflow: true,
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, `${cssBlock}__overflow-item`),
        overlayProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.overlayProps), {
          popperPlacement: overflowPopperPlacement,
          targetClassName: classnamesFn((_h = childProps === null || childProps === void 0 ? void 0 : childProps.overlayProps) === null || _h === void 0 ? void 0 : _h.targetClassName, `${cssBlock}__overflow-item`)
        }),
        iconProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.iconProps), {
          iconName: 'arrow-2-e'
        })
      };
    }
    if (child.displayName === 'SplitButton') {
      return {
        inToolbarOverflow: true,
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, `${cssBlock}__overflow-item`)
      };
    }
    if (child.displayName === 'ToolbarSeparator') {
      return {
        horizontal: true
      };
    }
    if (child.displayName === 'Tooltip') {
      return {
        placement: ['right', 'left']
      };
    }
    if (child.displayName === 'Checkbox') {
      return {
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, `${_constants.CSS_PREFIX}__overflow-checkbox`, `${cssBlock}__overflow-checkbox`, {
          [`${_constants.CSS_PREFIX}__overflow-checkbox-with-validation`]: ((_j = childProps === null || childProps === void 0 ? void 0 : childProps.validationMessage) === null || _j === void 0 ? void 0 : _j.state) && ((_k = childProps === null || childProps === void 0 ? void 0 : childProps.validationMessage) === null || _k === void 0 ? void 0 : _k.text),
          [`${cssBlock}__overflow-checkbox-with-validation`]: ((_l = childProps === null || childProps === void 0 ? void 0 : childProps.validationMessage) === null || _l === void 0 ? void 0 : _l.state) && ((_m = childProps === null || childProps === void 0 ? void 0 : childProps.validationMessage) === null || _m === void 0 ? void 0 : _m.text)
        }),
        innerTextClassName: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.innerTextClassName, `${cssBlock}__overflow-checkbox-text`),
        inputProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.inputProps), {
          className: classnames((_o = childProps === null || childProps === void 0 ? void 0 : childProps.inputProps) === null || _o === void 0 ? void 0 : _o.className, `${cssBlock}__overflow-checkbox-input`)
        })
      };
    }
    if (child.displayName === 'Link') {
      return {
        toolbarLayoutProps,
        inToolbarOverflow: true,
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, `${cssBlock}__overflow-item`, `${cssBlock}__overflow-link`)
      };
    }
    if (child.displayName === 'Select' || child.displayName === 'SelectPopoverField') {
      return {
        inToolbarOverflow: true
      };
    }
    if (child.displayName === 'DateSelect') {
      return {
        inToolbarOverflow: true
      };
    }
    if (child.displayName === 'DateRangeSelect') {
      return {
        inToolbarOverflow: true
      };
    }
    if (child.displayName === 'DateRangeInputField') {
      return {
        inToolbarOverflow: true
      };
    }
    if (child.displayName === 'TimePicker') {
      return {
        overlayProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.overlayProps), {
          popperPlacement: overflowPopperPlacement
        })
      };
    }
    if (child.displayName === 'InputField' || child.displayName === 'SelectField') {
      return {
        className: classnamesFn(childProps === null || childProps === void 0 ? void 0 : childProps.className, `${cssBlock}__overflow-field`, `${cssBlock}__overflow-field-padding`, `${cssBlock}__overflow-item--margin`, {
          [`${cssBlock}__overflow-field-padding--no-left`]: !hasLeftIcon
        })
      };
    }
    return {};
  }, [children, hasLeftIcon, hasRightIcon]);
  return /*#__PURE__*/_react.default.createElement(_Overlay.Overlay, Object.assign({
    maxWidth: 320
  }, overlayProps, {
    id: overflowDialogId,
    targetComponent: overflowTrigger,
    onShow: (0, _chainFunction.default)(() => toggle(true), overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onShow),
    onHide: (0, _chainFunction.default)(() => toggle(false), overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onHide, () => {
      var _a, _b;
      return ((_a = document === null || document === void 0 ? void 0 : document.activeElement) === null || _a === void 0 ? void 0 : _a.tagName) === 'BODY' && ((_b = overflowTriggerRef.current) === null || _b === void 0 ? void 0 : _b.focus());
    }),
    popperPlacement: (overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperPlacement) || 'bottom-end',
    "data-nui-widgets": "toolbar-overflow",
    onClickOutside: e => {
      var _a;
      return ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.closest('[data-nui-widgets="toolbar-overflow"]')) !== null;
    },
    disableFocusManager: true,
    popperContentProps: {
      style: {
        maxHeight,
        overflow: 'auto'
      }
    },
    className: classnames(`${cssBlock}__overlay`),
    show: isOverlayOpen
  }), /*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherProps, {
    className: classes,
    ref: (0, _reactMergeRefs.default)([ref, overflowRef])
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: addChildProps.bind(null, classnames)
  }, children)));
});
ToolbarOverflow.displayName = 'ToolbarOverflow';
var _default = exports.default = ToolbarOverflow;